import { render, staticRenderFns } from "./DebtorPaymentDetail.vue?vue&type=template&id=3a800a3e&scoped=true&"
import script from "./DebtorPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./DebtorPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./DebtorPaymentDetail.vue?vue&type=style&index=0&id=3a800a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a800a3e",
  null
  
)

export default component.exports